import c from "../../atom/language.mjs";
import { setLocalLanguage as l } from "@alpha-ess/utils";
import f from "antd/es/locale/cs_CZ";
import g from "antd/es/locale/de_DE";
import L from "antd/es/locale/el_GR";
import s from "antd/es/locale/en_US";
import h from "antd/es/locale/es_ES";
import d from "antd/es/locale/fr_FR";
import S from "antd/es/locale/it_IT";
import j from "antd/es/locale/ja_JP";
import C from "antd/es/locale/nl_NL";
import N from "antd/es/locale/pl_PL";
import R from "antd/es/locale/zh_CN";
import o from "dayjs";
import "dayjs/locale/cs";
import "dayjs/locale/de";
import "dayjs/locale/el";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/nl";
import "dayjs/locale/pl";
import "dayjs/locale/zh";
import b from "dayjs/plugin/updateLocale";
import { useMemo as J, useEffect as M } from "react";
import { useTranslation as P } from "react-i18next";
import { useSetRecoilState as v } from "recoil";
o.extend(b);
o.updateLocale("de", {
  monthsShort: "Jan_Feb_Mär_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Dez".split("_")
});
o.updateLocale("it", {
  monthsShort: "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_")
});
o.updateLocale("nl", {
  monthsShort: "jan_feb_maa_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_")
});
o.updateLocale("es", {
  monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_")
});
const A = () => {
  const r = v(c), { i18n: a } = P(), e = a.language, i = J(() => {
    switch (e) {
      case "zh-CN":
        return R;
      case "en-US":
        return s;
      case "de-DE":
        return g;
      case "ja-JP":
        return j;
      case "it-IT":
        return S;
      case "nl-NL":
        return C;
      case "sp-SP":
        return h;
      case "el-GR":
        return L;
      case "fr-FR":
        return d;
      case "pl-PL":
        return N;
      case "cs-CZ":
        return f;
      default:
        return s;
    }
  }, [e]);
  return M(() => {
    let t = e.split("-")[0];
    t === "sp" && (t = "es"), o.locale(t);
  }, [e]), {
    language: e,
    locale: i,
    setLanguage: (t) => {
      a.changeLanguage(t), r(t), l(t);
    },
    /** 根据语言设置宽度 */
    setColumnWidth: (t, p) => {
      const u = m(e);
      for (const n of t)
        if (n.language.map((_) => m(_)).includes(u)) return n.width;
      return p;
    }
  };
}, m = (r) => r.split("-")[0], it = A;
export {
  it as default
};
